import request from '@/system/engine/request';
import config from '@/system/engine/config';
import {getLocalStorage} from '@/system/store/localstorage';

export function sponsorAjaxTable(limit,pagination,id,created_at,sponsor_id,master_id){
	const data = request({
		url: config.url+'network/sponsorAjax?limit=' + limit + '&pagination=' + pagination + '&id=' + id + '&created_at=' + created_at + '&sponsor_id=' + sponsor_id + '&master_id=' + master_id,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function sponsorTree(login,uplevel){
	const data = request({
		url: config.url+'network/sponsorTree?login='+login+'&uplevel='+uplevel,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function getDownlineInfo(username){
	const data = request({
		url: config.url+'network/getDownlineInfo?username='+username,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function getUserInfo(username){
	const data = request({
		url: config.url+'network/getUserInfo?username='+username,
		method: 'get'
	});

	return Promise.resolve(data);
}	